import type { JSX } from 'react'
import type { ICheckboxProps } from '../CheckBox'

import { TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { Checkbox } from '../CheckBox'
import { Background, BorderColors } from '../CheckBox.h'
import { CheckBoxWrapper } from '../CheckBox.styled'

export interface ICheckBoxRememberMe extends Omit<
  ICheckboxProps,
  'id' | 'name'
> {
  id?: string
  name?: string
}

export const CheckBoxRememberMe = ({
  id = 'rememberMe',
  name = 'rememberMe',
  label,
  labelFont = TextBoxTypes.Caption4,
  labelColorDefault = TextBoxColors.TEXT_ICON_SECONDARY,
  backgroundChecked = Background.SURFACE_OPACITY_LIGHT_10,
  borderColor = BorderColors.SURFACE_OPACITY_LIGHT_10,
  borderColorHovered = BorderColors.SURFACE_OPACITY_LIGHT_10,
  borderColorChecked = BorderColors.SURFACE_OPACITY_LIGHT_10,
  ...rest
}: ICheckBoxRememberMe): JSX.Element => {
  return (
    <CheckBoxWrapper label={label}>
      <Checkbox
        id={id}
        name={name}
        label={label}
        labelFont={labelFont}
        labelColorDefault={labelColorDefault}
        backgroundChecked={backgroundChecked}
        borderColor={borderColor}
        borderColorHovered={borderColorHovered}
        borderColorChecked={borderColorChecked}
        {...rest}
      />
    </CheckBoxWrapper>
  )
}
